export default {
      id: "deco_e2-usage",
      viewBox: "0 0 605 500",
      url: "../../../plugins/creasit-builder/assets/dist/images/" + "sprite.svg#deco_e2-usage",
      toString: function () {
        return this.url;
      }
    }